"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectedSupplierSubscriberSelector = function (supplier) { return supplier || {}; };
exports.selectedSupplierIdSubscriberSelector = function (supplier) { return (Boolean(supplier) && supplier.id ? supplier.id : ''); };
exports.allSuppliersSubscriberSelector = function (suppliers) { return suppliers || []; };
exports.allSuppliersIdSelector = function (suppliers) { return (Boolean(suppliers) ? suppliers.map(function (_a) {
    var id = _a.id;
    return id;
}) : []); };
exports.selectedSupplierCountryListSubscriberSelector = function (countryList) { return countryList || []; };
